import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { FaMapMarkerAlt, FaCalendarAlt, FaUsers, FaSearch } from 'react-icons/fa';
import '../../../assets/css/customer/events/EventHero.css';

const EventHero = () => {

  const [formData, setFormData] = useState({
    weddingVenue: '',
    location: '',
    guests: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Search Data:', formData);
    alert(
      `Searching for: ${formData.weddingVenue} in ${formData.location} for ${formData.guests} guests`
    );
  };

  return (
    <section className="ehs-hero-section">
      <div className="ehs-overlay"></div>

      <Container className="ehs-container">
        <Row className="align-items-center">
          <Col lg={12} className="text-center">

            <div className="ehs-title-wrapper">
              <h1 className="ehs-main-title">
                Find the Perfect Wedding Venue
              </h1>
              <p className="ehs-subtitle">
                Discover beautiful spaces where love begins and memories last forever
              </p>
            </div>

            <div className="ehs-search-card">
              <div className="ehs-deco-lantern ehs-lantern-left"></div>
              <div className="ehs-deco-lantern ehs-lantern-right"></div>

              <div className="ehs-car-wrapper">
                <svg className="ehs-car-svg" viewBox="0 0 200 100" xmlns="http://www.w3.org/2000/svg">
                  <ellipse cx="100" cy="70" rx="50" ry="20" fill="#ff69b4" opacity="0.3" />
                  <rect x="60" y="50" width="80" height="30" rx="15" fill="#ff69b4" />

                  <circle cx="75" cy="75" r="10" fill="#333" />
                  <circle cx="75" cy="75" r="6" fill="#666" />
                  <circle cx="125" cy="75" r="10" fill="#333" />
                  <circle cx="125" cy="75" r="6" fill="#666" />

                  <circle cx="85" cy="55" r="8" fill="#fff" />
                  <circle cx="105" cy="55" r="8" fill="#fff" />
                  <path d="M 80 63 Q 85 68 90 63" fill="#fff" />
                  <path d="M 100 63 Q 105 68 110 63" fill="#fff" />
                </svg>
              </div>
 
               <div className="ehs-deco-icon ehs-icon-left">🎭</div>
              <div className="ehs-deco-icon ehs-icon-right">💐</div>
            </div> 

            <Form onSubmit={handleSubmit} className="ehs-form">
              <Row className="g-3">

                <Col md={4} sm={12}>
                  <div className="ehs-input-group">
                    <div className="ehs-input-icon">
                      <FaMapMarkerAlt />
                    </div>
                    <Form.Select
                      name="weddingVenue"
                      value={formData.weddingVenue}
                      onChange={handleInputChange}
                      className="ehs-form-control"
                      required
                    >
                      <option value="">Wedding Venue</option>
                      <option value="banquet-hall">Banquet Hall</option>
                      <option value="garden">Garden Venue</option>
                      <option value="beach">Beach Resort</option>
                      <option value="hotel">Hotel Ballroom</option>
                      <option value="farmhouse">Farmhouse</option>
                      <option value="destination">Destination Wedding</option>
                    </Form.Select>
                  </div>
                </Col>

                <Col md={4} sm={12}>
                  <div className="ehs-input-group">
                    <div className="ehs-input-icon">
                      <FaCalendarAlt />
                    </div>
                    <Form.Control
                      type="text"
                      name="location"
                      placeholder="Bangalore, India"
                      value={formData.location}
                      onChange={handleInputChange}
                      className="ehs-form-control"
                      required
                    />
                  </div>
                </Col>

                <Col md={4} sm={12}>
                  <div className="ehs-input-group">
                    <div className="ehs-input-icon">
                      <FaUsers />
                    </div>
                    <Form.Select
                      name="guests"
                      value={formData.guests}
                      onChange={handleInputChange}
                      className="ehs-form-control"
                      required
                    >
                      <option value="">Number of Guests</option>
                      <option value="50-100">50-100 Guests</option>
                      <option value="100-200">100-200 Guests</option>
                      <option value="200-300">200-300 Guests</option>
                      <option value="300-500">300-500 Guests</option>
                      <option value="500+">500+ Guests</option>
                    </Form.Select>
                  </div>
                </Col>

              </Row>

              <div className="ehs-button-wrapper">
                <Button type="submit" className="ehs-submit-btn">
                  <FaSearch className="ehs-btn-icon" />
                  Get Started Now
                </Button>
              </div>
            </Form>

          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default EventHero;
